// extracted by mini-css-extract-plugin
export default {"notification":"styles_notification__W9p40","notification__icon":"styles_notification__icon__MYUo0","notification__inner":"styles_notification__inner__P34Zm"};